import React from "react";

// Same labels and order as the real tables, so clicking Search fills in this layout rather than replacing it.
const COLUMNS = {
  contacts: [
    { label: "Contact", w: 280, lead: true },
    { label: "Title", w: 220 },
    { label: "Company", w: 220 },
    { label: "Contact Info", w: 210 },
    { label: "Contact Location", w: 200 },
    { label: "Department", w: 180 },
    { label: "Seniority", w: 160 }
  ],
  companies: [
    { label: "Company", w: 312, lead: true },
    { label: "Website", w: 220 },
    { label: "Location", w: 195 },
    { label: "Industry", w: 195 },
    { label: "Description", w: 280 },
    { label: "Company Size", w: 143 }
  ]
};

// Varied bar widths so the rows read as data, not a grid.
const WIDTHS = ["72%", "55%", "84%", "60%", "78%", "48%", "66%", "90%"];
const ROWS = 8;

/**
 * Static outline of the results table, under the "Filters selected. Click Search" banner. Deliberately not
 * animated: nothing is loading until the user searches.
 */
const PendingTableOutline = ({ companies = false }) => {
  const columns = COLUMNS[companies ? "companies" : "contacts"];
  return (
    <div className="lbOutline" aria-hidden="true">
      <div className="lbOutline__row lbOutline__row--head">
        <span className="lbOutline__check" />
        {columns.map(col => (
          <span key={col.label} className="lbOutline__cell" style={{ width: col.w }}>
            {col.label}
          </span>
        ))}
      </div>
      {Array.from({ length: ROWS }, (_, r) => (
        <div className="lbOutline__row" key={r}>
          <span className="lbOutline__check">
            <span className="lbOutline__box" />
          </span>
          {columns.map((col, c) =>
            col.lead ? (
              <span key={col.label} className="lbOutline__cell lbOutline__cell--lead" style={{ width: col.w }}>
                <span className={`lbOutline__avatar${companies ? " lbOutline__avatar--square" : ""}`} />
                <span className="lbOutline__stack">
                  <span className="lbOutline__bar" style={{ width: WIDTHS[r % WIDTHS.length] }} />
                  <span className="lbOutline__bar lbOutline__bar--sub" style={{ width: "34%" }} />
                </span>
              </span>
            ) : (
              <span key={col.label} className="lbOutline__cell" style={{ width: col.w }}>
                <span className="lbOutline__bar" style={{ width: WIDTHS[(r + c * 3) % WIDTHS.length] }} />
              </span>
            )
          )}
        </div>
      ))}
    </div>
  );
};

export default PendingTableOutline;
